import Cookies from 'js-cookie';

// Get all mobile CTA buttons
const allMobileCtaLinks = document.querySelectorAll(
  '.wp-block-button__link__app-store-badge, .wp-block-button__link__google-play-badge',
);

if (allMobileCtaLinks.length) {
  const flp = Cookies.get('flp.v2');
  const r = Cookies.get('r');

  allMobileCtaLinks.forEach((link) => {
    const linkObj = new URL(link.href);

    if (window.location.host !== linkObj.hostname) {
      const params = new URLSearchParams(linkObj.search);

      // Set First Landing Page param if cookie exists.
      if (flp) {
        params.set('lp', flp);
        linkObj.search = params.toString();

        // eslint-disable-next-line no-param-reassign -- Set href attribute
        link.href = linkObj.toString();
      }

      // Set Referer param if cookie exists.
      if (r) {
        params.set('referrer', r);
        linkObj.search = params.toString();

        // eslint-disable-next-line no-param-reassign -- Set href attribute
        link.href = linkObj.toString();
      }
    }
  });
}
